import React, { useRef, useState } from 'react'
import { StyleSheet } from 'react-native'
import { useResponsive } from '@linqpal/components/src/hooks'
import { BtAlert, BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { ExclamationRed } from '../../../../assets/icons'
import { Spacer } from '../../../../ui/atoms'
import {
  PlaidConnectButton,
  PlaidConnectButtonRef,
} from '../../../../ui/add-payment-method-components/PlaidConnectButton'
import { observer } from 'mobx-react'

interface FinicityConnectionErrorProps {
  visible: boolean
  onClose: () => void
  finicityBankId: string
}

export const FinicityConnectionError: React.FC<FinicityConnectionErrorProps> =
  observer(({ visible, onClose, finicityBankId = '' }) => {
    const { sm } = useResponsive()
    const { t } = useTranslation('global')
    const ref = useRef<PlaidConnectButtonRef>(null)
    const [loading, setLoading] = useState(false)

    return (
      <>
        <BtAlert
          visible={visible}
          icon={
            <ExclamationRed
              width={48}
              height={48}
              style={{ marginBottom: sm ? 35 : 20 }}
            />
          }
          width={sm ? 610 : 365}
          type={'danger'}
          onClose={onClose}
          buttons={[
            {
              label: 'Connect Bank Account',
              onPress: () => {
                ref.current?.createToken()
              },
              style: { marginBottom: sm ? 20 : 0, width: 310, borderRadius: 4 },
              loading: loading,
            },
          ]}
        >
          <BtText style={sm ? styles.titleDesktop : styles.titleMobile}>
            {t('Wallet.connection-error')}
          </BtText>
          <Spacer />
          <BtText style={sm ? styles.messageDesktop : styles.messageMobile}>
            {t('Wallet.connection-error-text')}
          </BtText>
        </BtAlert>
        <PlaidConnectButton
          ref={ref}
          setLoading={setLoading}
          onConnectSuccess={onClose}
        />
      </>
    )
  })

const styles = StyleSheet.create({
  titleDesktop: {
    color: '#003353',
    fontSize: 28,
    fontWeight: '700',
  },
  titleMobile: {
    color: '#003353',
    fontSize: 18,
    fontWeight: '600',
  },
  messageDesktop: {
    fontSize: 18,
    fontWeight: '400',
    lineHeight: 26,
    textAlign: 'center',
    color: '#082131',
    width: 450,
    marginBottom: 20,
  },
  messageMobile: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 21,
    textAlign: 'center',
    color: '#668598',
    width: 250,
    marginBottom: 15,
  },
})
